import { Handles } from '../utils/userSettings';
import { assertResponse, getJson } from './Utils';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

// The signed-in player's saved handles. Only needed when localStorage doesn't already have them.
async function getHandles(): Promise<Handles> {
  const response = await fetch('/api/UserNames/handles');
  return (await getJson<Handles>(response)) ?? {};
}

// --- Searched player names (the managed Player-filter dropdown) ------------------------------
// The handles the user looks up. Auto-remembered on search, pruned by the user. All require auth;
// the caller only invokes these for a signed-in visitor (the endpoints 401 otherwise).

async function getSearchNames(): Promise<string[]> {
  const response = await fetch('/api/UserNames/searches');
  return (await getJson<string[]>(response)) ?? [];
}

async function addSearchName(username: string): Promise<void> {
  const response = await fetch('/api/UserNames/searches', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Username: username }),
  });
  await assertResponse(response);
}

async function removeSearchName(username: string): Promise<void> {
  const response = await fetch('/api/UserNames/searches?username=' + encodeURIComponent(username), {
    method: 'DELETE',
  });
  await assertResponse(response);
}

export default {
  getHandles,
  getSearchNames,
  addSearchName,
  removeSearchName,
};
